<template>
  <v-navigation-drawer
    fixed
    right
    temporary
    width="520"
    overlay-opacity="0.7"
    class="pa-0"
    :value="visible"
    @input="checkDrawerValue"
  >
    <div v-if="isLoading" class="h-100 d-flex align-center justify-center">
      <LoaderSpinner />
    </div>
    <EmptyState
      v-if="!isLoading && !findingId"
      style="height: 100vh"
      :title="$t('assignments.address_empty_state_title')"
      :message="$t('assignments.address_empty_state_message')"
    />
    <FindingEditForm
      v-if="!isLoading"
      :finding="selectedFinding"
      :routine="selectedRoutine"
      @saved="$emit('close')"
      @cancel="$emit('close')"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import mixin from '@/mixins/mixin.vue'

import FindingEditForm from '@/components/FindingEditForm/FindingEditForm.vue'
import LoaderSpinner from '@/components/utils/LoaderSpinner.vue'
import EmptyState from '@/components/EmptyState.vue'

export default {
  name: 'FindingEditDrawer',

  mixins: [mixin],

  components: {
    FindingEditForm,
    LoaderSpinner,
    EmptyState,
  },

  props: {
    visible: Boolean,
    findingId: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      selectedFinding: {},
      selectedRoutine: {},
      isLoading: true,
    }
  },

  async mounted() {
    await this.fetchAllData()
  },

  computed: {
    ...mapGetters(['organizationId']),
  },

  methods: {
    checkDrawerValue(val) {
      if (val) return
      this.$emit('close')
    },

    async fetchFinding() {
      const response = await api.findings.getById({
        organizationId: this.organizationId,
        findingId: this.findingId,
        relations: ['tags', 'assignees', 'media'],
      })

      this.selectedFinding = response.data
    },

    async fetchRoutine() {
      const response = await api.routine.getExecutionById(
        this.organizationId,
        this.selectedFinding.routine
      )

      this.selectedRoutine = response?.data ?? {}
    },

    async fetchAllData() {
      try {
        await this.fetchFinding()
        await this.fetchRoutine()
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.loading__container {
  height: 100vh;
}
</style>
